module.exports = __webpack_public_path__ + "static/quebecTap-9ec3deb1cb23c4930c9e97af3af64afc.mp3";